module.exports = __webpack_public_path__ + "img/disconnected.2205375f.png";